import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React, { useMemo } from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import {
  IServiceInterfaceLog,
  IServiceInterfaceLogType,
} from "@/interfaces/service-interface.interface";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { ServiceInterfaceLogTableRow } from "./row";
import { SERVICE_INTERFACE_LOG_TABLE_COLUMNS } from "../../constants";

type Props = {
  data: PaginatedResponse<IServiceInterfaceLog>;
  pagination: Pagination;
  messages: ServiceInterfaceMessages;
  logTypes: IServiceInterfaceLogType[];
};

export function ServiceInterfaceLogTable({ data, pagination, messages, logTypes }: Props) {
  const { pageNumber, pageSize, changePage, extend } = pagination;

  const resolveLogTypeLabel = useMemo(() => {
    const map = new Map(logTypes.map((t) => [t.code, t.label]));
    return (code: string) => map.get(code) ?? code;
  }, [logTypes]);

  const columns = SERVICE_INTERFACE_LOG_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="integration-logs-table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell key={`${index}-${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items.map((log, index) => (
              <ServiceInterfaceLogTableRow
                key={log.id}
                log={log}
                index={index}
                messages={messages}
                resolveLogTypeLabel={resolveLogTypeLabel}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, page) => changePage(page)}
      />
    </>
  );
}
